import * as React from 'react';
import { Popover, UIText3 } from '@cian/ui-kit';
import cn from 'classnames';
import * as styles from './styles.css';
import { widgetContext } from '../../context/widgetContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var ErrorPopover = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      placement = props.placement,
      tooltipContent = props.tooltipContent,
      wrapWith = props.wrapWith;

  var _React$useContext = React.useContext(widgetContext),
      isDesktop = _React$useContext.isDesktop;

  return /*#__PURE__*/_jsx(Popover, {
    open: Boolean(tooltipContent),
    content: /*#__PURE__*/_jsx("div", {
      className: cn(styles['error-container'], !isDesktop && styles['mobile']),
      children: /*#__PURE__*/_jsx(UIText3, {
        color: "current_color",
        children: tooltipContent
      })
    }),
    placement: isDesktop ? placement || 'bottom-start' : 'bottom-start',
    flip: false,
    preventOverflow: false,
    children: wrapWith ? /*#__PURE__*/React.createElement(wrapWith, {
      ref: ref
    }, children) : /*#__PURE__*/React.cloneElement(children, {
      ref: ref
    })
  });
});
ErrorPopover.displayName = 'ErrorPopover';